/**
 * Created by eliranm on 06/10/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var LEResourceResolver = require("leResourceResolver");
    var Link = require('ui/link/Link');
    var FileUploadInput = require('ui/file-upload-input/FileUploadInput');
    var Button = require('ui/button/Button');
    var template = require('content-templates/content-import/contentImportInstructions.tmpl');
    var Config = require('content-config/contentImportConfig.json');

    var ContentImportInstructionsView = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportInstructionsView = Marionette.ItemView.extend({

            template: template,

            ui: {
                downloadTemplateLink: '.link-download-template',
                downloadContentLink: '.link-download-content',
                upload: '.file-upload-input'
            },

            uiComponents: {
                downloadTemplateLink: {
                    type: Link,
                    options: {
                        text: LE.translator.translate(Config.i18n.downloadTemplateLink),
                        href: function() {
                            if (LE.siteSettings.accountSettings.isAcUser()) {
                                return LEResourceResolver.getUrl(LEResourceResolver.apiResources.lpCdnBasePath) + Config.cdn.skillsTemplatePath;
                            } else {
                                return LEResourceResolver.getUrl(LEResourceResolver.apiResources.lpCdnBasePath) + Config.cdn.templatePath;
                            }
                        },
                        el: 'view.ui.downloadTemplateLink'
                    }
                },
                downloadContentLink: {
                    type: Button,
                    options: {
                        permutation: Button.PERMUTATION.BLUELINK,
                        text: LE.translator.translate(Config.i18n.downloadContentLink),
                        el: 'view.ui.downloadContentLink'
                    },
                    events: {
                        click: '_onDownloadContent'
                    }
                },
                upload: {
                    type: FileUploadInput,
                    options: {
                        el: 'view.ui.upload',
                        uploadUrl: LEResourceResolver.getUrl(LEResourceResolver.apiResources.AccountConfig.Import) + "&include_skills=" + LE.siteSettings.accountSettings.isAcUser() ,
                        sessionToken: LE.sessionManager.getGlob(),
                        uploadTimeout: 600000,
                        uploadExtensions: [
                            'csv'
                        ],
                        errorPosition: FileUploadInput.ERROR_POSITION.BOTTOM
                    }
                }
            },


            // overridden

            initialize: function (options) {
                this.vent = options.vent;
            },

            onRender: function () {
                this.listenTo(this.uiComponents.upload, FileUploadInput.EVE.fileSelectionChange, this._onUploaderFileSelectionChange);
                this.listenTo(this.uiComponents.upload, FileUploadInput.EVE.uploadStart, this._onUploaderUploadStart);
                this.listenTo(this.uiComponents.upload, FileUploadInput.EVE.uploadComplete, this._onUploaderUploadComplete);
                this.listenTo(this.uiComponents.upload, FileUploadInput.EVE.initSuccess, this._onUploaderInitSuccess);
                this.listenTo(this.uiComponents.upload, FileUploadInput.EVE.error, this._onUploaderError);
            },

            onClose: function () {
                this.uiComponents.upload.close();
            },


            // public

            startUpload: function () {
                this.uiComponents.upload.startUpload();
            },

            setFileUploadError: function (msg) {
                this.uiComponents.upload.setError(msg);
            },


            // private

            _onDownloadContent: function () {
                this.vent.trigger(Config.events.downloadCurrentContent);
            },

            _onUploaderUploadStart: function (data) {
                this.vent.trigger(Config.events.uploader.uploadStart, data);
            },

            _onUploaderUploadComplete: function (data) {
                this.vent.trigger(Config.events.uploader.uploadComplete, data);
            },

            _onUploaderInitSuccess: function (data) {
                this.vent.trigger(Config.events.uploader.initSuccess, data);
            },

            _onUploaderError: function (data) {
                this.vent.trigger(Config.events.uploader.error, data);
            },

            _onUploaderFileSelectionChange: function (data) {
                this.uiComponents.upload.removeError();
                this.vent.trigger(Config.events.uploader.fileSelectionChange, data);
            }

        });
    });

    return ContentImportInstructionsView;
});
